import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../axiosinterceptor';

const initialState = {
    workflowCount: {
        codesCountsData: {},
        codesCountsLoading: false,
        codesCountsError: null
    },
};

export const getWorkflowsCountData = createAsyncThunk(
  '/getWorkflowsCountData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.get('/get_him_workspace');
      if(response.data) {
        return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

const codeWorkflowSlicer = createSlice({
  name: "codeWorkflowSlicer",
  initialState,
  reducers: {
  
  },
  extraReducers: (builder) => builder
.addCase(getWorkflowsCountData.pending, (state) => {
    state.workflowCount.codesCountsLoading = true;
    state.workflowCount.codesCountsError = null;
  }).addCase(getWorkflowsCountData.fulfilled, (state,action) => {
    state.workflowCount.codesCountsLoading = false;
    state.workflowCount.codesCountsData = action.payload;
  }).addCase(getWorkflowsCountData.rejected, (state, action) => {
    state.workflowCount.codesCountsLoading = false;
    state.workflowCount.codesCountsError = action.payload;
  })
});

export const {} = codeWorkflowSlicer.actions;

export default codeWorkflowSlicer.reducer;
